export default {
  NOT_SENT: 0,
  NOT_FILLED: 1,
  SENT: 2,
  DONE: 3,
};
